import {useEffect,useState} from 'react';
import {Permissions as P} from '@myfm/domain';
import {api} from '../api';
import {Link} from '../ui/ScopedLink';
import {useStaffSession} from '../ui/StaffSession';
import {withBuildingScope} from '../ui/building-scope';
import {withWorkflowReturn} from '../ui/WorkflowReturn';
import {ErrorState,Loading,reviewedApplicationError} from '../ui/State';

type Document={id:string;title:string;category:string;verification_status:string};
type Props={building:string;category:string;label:string;returnTo:string;revision?:number};
export function OnboardingDocumentList(props:Props){
 const session=useStaffSession();
 const allowed=session?.capabilities.includes(P.ViewDocuments)&&session.capabilities.includes(P.ViewClientOnboarding);
 return allowed?<ReceivedDocuments key={`${props.building}:${props.category}:${session?.capabilities.join('|')}`} {...props}/>:null;
}
function ReceivedDocuments({building,category,label,returnTo,revision=0}:Props){
 const [documents,setDocuments]=useState<Document[]>(),[error,setError]=useState<unknown>(),[retry,setRetry]=useState(0);
 useEffect(()=>{
  setDocuments(undefined);setError(undefined);
  const controller=new AbortController();
  void api<{building:string;documents:Document[]}>(withBuildingScope(`/api/building-onboarding/${building}/documents`,building),{signal:controller.signal}).then(value=>{
   if(value.building!==building||!Array.isArray(value.documents))throw reviewedApplicationError('These originals could not be confirmed for this building.');
   if(!controller.signal.aborted)setDocuments(value.documents.filter(d=>d.category===category));
  }).catch(cause=>{if(!controller.signal.aborted)setError(cause)});
  return()=>controller.abort();
 },[building,category,revision,retry]);
 return <section className="panel" aria-label={`${label} received during onboarding`}><h2>{label} received during onboarding</h2>
  {Boolean(error)&&<ErrorState error={error} onRetry={()=>setRetry(n=>n+1)}/>}{!documents&&!error&&<Loading/>}
  {documents&&(documents.length?<ul>{documents.map(document=><li key={document.id}><Link to={withWorkflowReturn(withBuildingScope(`/documents/${document.id}`,building),returnTo)}>{document.title}</Link> · {document.verification_status==='Unverified'?'Awaiting review':document.verification_status}</li>)}</ul>:<p>No matching original is listed among the most recent onboarding receipts.</p>)}
  <p>This list uses the latest 100 onboarding receipts. <Link to={withWorkflowReturn(withBuildingScope('/documents',building),returnTo)}>Review all existing building documents</Link> for older originals and documents received elsewhere.</p>
 </section>;
}
